import styled from 'styled-components';

export const SetDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 48px;
  min-height: 100vh;
`;

export const DetailsContainer = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const SetStats = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-weight: 500;
`;

export const ChecklistPath = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  font-size: 12px;
`;

export const LoadingSpinner = styled.div`
  color: #FFFFFF;
  text-align: center;
  padding: 40px;
  font-size: 16px;
`;

export const ErrorMessage = styled.div`
  color: #ff6b6b;
  text-align: center;
  padding: 20px;
  font-size: 14px;
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.3);
  border-radius: 8px;
`;

export const EmptyState = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 214px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  gap: 16px;
  width: 100%;

`;

export const SetDescription = styled.div`
  margin: 8px 0px;
`;

export const DatePill = styled.div`
    align-items: center;
    border: 2px solid rgb(255, 255, 255, 0.33);
    border-radius: 100px;
    cursor: pointer;
    display: flex;
    gap: 8px;
    height: 40px;
    padding: 0px 20px;
    transition: 0.4s;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

export const TagsLabel = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  font-weight: 500;
`;

export const TagsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const TagItem = styled.span`
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
  white-space: nowrap;
  gap: 6px;
`;

export const TagRemoveButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  padding: 0;
  margin-left: 4px;
  transition: color 0.2s ease;

  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
`;

export const EbaySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;

export const InfoLabelContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const InfoLabel = styled.h4`
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const CopyConfirmation = styled.span`
  color: #4CAF50;
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  transition: opacity 0.2s ease;
`;

export const EbayTitleInput = styled.input`
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 12px;
  font-family: inherit;
  cursor: text;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.4);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

export const EbayDescriptionText = styled.textarea`
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding: 12px;
  min-height: 360px;
  resize: vertical;
  font-family: inherit;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  cursor: text;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.4);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;